import { useState } from 'react'
import { createItemUploads } from '../../file/fileActions.js'
import { UPLOAD_SOURCE } from '../../../global/utils/uploadSource.js'

/**
 * Custom hook for handling file upload process and progress tracking
 */
export const useFileUpload = () => {
  const [submitting, setSubmitting] = useState(false)
  const [uploadItems, setUploadItems] = useState({})

  const submitFiles = async params => {
    const { files, dispatch, requestParams } = params

    setSubmitting(true)

    try {
      const createdFolders = []
      const uploads = dispatch(
        createItemUploads({
          files,
          folders: createdFolders,
          params: {
            uploadSource: UPLOAD_SOURCE.REQUEST_TASK,
            ...requestParams,
          },
        }),
      ).map(async upload => {
        for await (const { type, value } of upload) {
          if (type === 'progress') {
            const {
              root: { _id, name },
              percent,
            } = value
            setUploadItems(prev => ({
              ...prev,
              [_id]: { ...prev[_id], name, percent },
            }))
          }

          if (type === 'failedMessages') {
            const {
              root: { _id, name },
              failedMessages,
            } = value
            setUploadItems(prev => ({
              ...prev,
              [_id]: { ...prev[_id], name, failedMessages },
            }))
          }

          if (type === 'done') {
            return value
          }
        }
      })

      const results = await Promise.allSettled(uploads)

      const { createdFiles } = results
        .map(({ value }) => value)
        .reduce(
          (acc, { root, createdFiles, failedMessages }) => {
            acc.roots = [...acc.roots, root]
            acc.createdFiles = [...acc.createdFiles, ...createdFiles]
            acc.failedMessages = [...acc.failedMessages, ...failedMessages]
            return acc
          },
          { roots: [], createdFiles: [], failedMessages: [] },
        )

      return { createdFiles }
    } finally {
      setSubmitting(false)
    }
  }

  const clearUploadItems = () => {
    setUploadItems({})
  }

  return {
    submitting,
    uploadItems,
    submitFiles,
    clearUploadItems,
  }
}
